import { render, staticRenderFns } from "./TeacherScoreInput.vue?vue&type=template&id=00053bc8"
import script from "./TeacherScoreInput.vue?vue&type=script&lang=js"
export * from "./TeacherScoreInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports